import Nullstack from 'nullstack';
export default function IconDoorExit({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-door-exit",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M13 12v.01"
  }), "   ", Nullstack.element("path", {
    d: "M3 21h18"
  }), "   ", Nullstack.element("path", {
    d: "M5 21v-16a2 2 0 0 1 2 -2h7.5m2.5 10.5v7.5"
  }), "   ", Nullstack.element("path", {
    d: "M14 7h7m-3 -3l3 3l-3 3"
  }), " ");
}